import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-12 md:pt-12" }
const _hoisted_2 = { class: "grid grid-cols-1 xl:grid-cols-4 gap-y-8 gap-x-0 xl:gap-x-8 mb-16" }
const _hoisted_3 = { class: "col col-span-1" }
const _hoisted_4 = { class: "col col-span-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 lg:px-0" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-6 text-white" }, "My Stakes")
], -1)
const _hoisted_6 = { class: "grid grid-cols-1 xl:grid-cols-4 gap-y-8 gap-x-0 xl:gap-x-8 mb-12" }
const _hoisted_7 = { class: "col-span-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, "My Pools", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "mb-12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioHeader = _resolveComponent("PortfolioHeader")!
  const _component_PortfolioAssetsPieChart = _resolveComponent("PortfolioAssetsPieChart")!
  const _component_PortfolioValueLineChart = _resolveComponent("PortfolioValueLineChart")!
  const _component_PortfolioPoolsStatCards = _resolveComponent("PortfolioPoolsStatCards")!
  const _component_PortfolioStatWithBarChart = _resolveComponent("PortfolioStatWithBarChart")!
  const _component_PortfolioPoolsPieChart = _resolveComponent("PortfolioPoolsPieChart")!
  const _component_PoolsTable = _resolveComponent("PoolsTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PortfolioHeader, {
      data: _ctx.portfolio,
      "is-loading": _ctx.isLoadingPortfolio || _ctx.isLoadingPools || _ctx.isLoadingFarms,
      pools: _ctx.poolsWithUserInFarm
    }, null, 8, ["data", "is-loading", "pools"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PortfolioAssetsPieChart, {
          assets: _ctx.portfolio.tokens,
          "is-loading": _ctx.isLoadingPortfolio
        }, null, 8, ["assets", "is-loading"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PortfolioValueLineChart, {
          assets: _ctx.portfolio.tokens,
          data: _ctx.portfolioHistory,
          "is-loading": _ctx.isLoadingPortfolio
        }, null, 8, ["assets", "data", "is-loading"])
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_PortfolioPoolsStatCards, {
          pools: _ctx.portfolio.pools,
          "is-loading": _ctx.isLoadingPortfolio
        }, null, 8, ["pools", "is-loading"]),
        _createElementVNode("div", null, [
          _createVNode(_component_PortfolioStatWithBarChart, {
            title: "Fees Earned (24h)",
            "sub-title": `Avg: ${_ctx.fNum(_ctx.avgFees, 'usd')}/day`,
            stat: _ctx.fNum(_ctx.portfolio.myFees, 'usd'),
            "info-text": "The swap fees you've earned as a liquidity provider. 'Fees Earned (24h)' are the fees you've earned in the last 24 hours. The bar chart to the right shows the daily fees you've earned. Daily snapshots are taken at 00:00 UTC.",
            dates: _ctx.timestamps,
            data: _ctx.fees,
            "bar-color": _ctx.chartColors[2],
            "is-loading": _ctx.isLoadingPortfolio
          }, null, 8, ["sub-title", "stat", "dates", "data", "bar-color", "is-loading"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_PortfolioPoolsPieChart, {
          pools: _ctx.portfolio.pools,
          "is-loading": _ctx.isLoadingPortfolio
        }, null, 8, ["pools", "is-loading"])
      ])
    ]),
    (_ctx.isWalletReady && _ctx.userPools && _ctx.userPools.length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_8,
          _createVNode(_component_PoolsTable, {
            isLoading: _ctx.isLoadingUserPools,
            data: _ctx.userPools,
            noPoolsLabel: _ctx.$t('noInvestments'),
            showPoolShares: "",
            class: "mb-8"
          }, null, 8, ["isLoading", "data", "noPoolsLabel"]),
          _hoisted_9
        ], 64))
      : _createCommentVNode("", true)
  ]))
}